module.exports = __webpack_public_path__ + "img/4_1_m.58f58e69.jpg";